export const ListItem = ({ children }) => {
  return (
    <div className="border-b border-gray-200 dark:border-gray-700 pb-1 last-of-type:border-none">
      {children}
    </div>
  );
};
